import React, { useState } from "react";
import { Modal, Container, Row, Col, Form, Button } from "react-bootstrap";
//import React, { Component } from "react";
//import { Button, Modal } from "react-bootstrap";
import { css } from "aphrodite";
import styles from "./style";
import { getValue } from "@testing-library/user-event/dist/utils";
import "./CustomModal.css";

export default function CustomModal({
  show,
  data,
  message,
  handleClose,
  handleConfirm,
  title,
  modalType,
  hideText
}) {
  const [isConfirm, setIsConfirm] = useState(false);
  const [comment, setComment] = useState("");
  const handleModalClose = () => {
    setIsConfirm(false);
    setComment("");
    handleClose();
  };
  const handleModalConfirm = () => {
    if (hideText || comment.length > 0) {
      handleConfirm(data, comment);
      handleModalClose();
    }
  };
  return (
    <Modal show={show} backdrop="static"
      keyboard={false} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : 'Confirm'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>{message}</Col>
          </Row>
          {!hideText && isConfirm && (
            <Row>
              <Col>
                <Form>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Please add reason to delete </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      isInvalid={comment.length <= 0}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>
      <Modal.Footer style={{justifyContent: "center"}}>
        {modalType === 'alert' && <Button variant="secondary" onClick={handleModalClose}>
          Ok
        </Button>}
        {modalType !== 'alert' && <>
          <Button variant="secondary" onClick={handleModalClose}>
            Close
          </Button>
          {(!isConfirm || hideText) && (
            <Button variant="primary" onClick={() => hideText ? handleModalConfirm() : setIsConfirm(true)}>
              Yes
            </Button>
          )}
          {(isConfirm && !hideText) && (
            <Button variant="primary" onClick={handleModalConfirm}>
              Confirm
            </Button>
          )}</>}
      </Modal.Footer>
    </Modal>
  );
}




// class CustomModal extends Component {
//   handleChange = (val, fieldName, callback) => {
//     callback(fieldName, val);
//   };
//   render() {
//     const {
//       name,
//       action,
//       header,
//       title,
//       show,
//       size,
//       close,
//       save,
//       confirmButtons = true,
//       closeButton,
//       type,
//     } = this.props;
//     const bgClass = type==='warning'?styles.warningModalHeaderBackground:(type==='error'?styles.errorModalHeaderBackground:'');
//     return (
//       <div>
//         <Modal
//           size={size}
//           show={show}
//           onHide={close}
//           centered={true}
//           backdrop="static"
//           keyboard={false}
//         >
//           <Modal.Header className={header !== "" ? css(styles.modalHeader, bgClass) : css(styles.withoutHeaderClass)}  closeButton={closeButton} closeVariant="white">
//             <Modal.Title className={css(styles.modalTitle)}>{header}</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className={css(styles.modalBody)}>
//             <span style={{textAlign:'left', display:'inline-block'}} dangerouslySetInnerHTML={{__html:title}}/>
//           </Modal.Body>
//           <Modal.Footer className={css(styles.modalFooter)}>
//             {confirmButtons ? (
//               <>
//                 <Button
//                   className={css(styles.buttonStyle)}
//                   variant="primary"
//                   onClick={() => this.handleChange(true, name, action)}
//                 >
//                   Yes
//                 </Button>
//                 <Button
//                   className={css(styles.buttonStyle)}
//                   variant="secondary"
//                   onClick={() => this.handleChange(false, name, action)}
//                 >
//                   No
//                 </Button>
//               </>
//             ) : (
//               <Button
//                 className={css(styles.buttonStyle)}
//                 style={{textAlign: "center"}}
//                 variant="primary"
//                 onClick={() => this.handleChange(true, name, action)}
//               >
//                 Ok
//               </Button>
//             )}
//           </Modal.Footer>
//         </Modal>
//       </div>
//     );
//   }
// }

//export default CustomModal;
